import axios from "axios";
import {stripSpaces} from "./api-util";

const BASE_API_URL = "/web/rest-fp/address";

export function getAddress(postalCode, houseNumber, houseNumberAddition) {
  let normalizedPostalCode = stripSpaces(postalCode);
  let normalizedHouseNumber = stripSpaces(houseNumber) + stripSpaces(houseNumberAddition);

  return axios
    .get(`${BASE_API_URL}/${normalizedPostalCode}/${normalizedHouseNumber}`)
    .then(result => result.data);
}
